<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        เพิ่มบริษัทของผู้ให้บริการ
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> จัดการรายชื่อผู้ให้บริการ
          </a>
        </li>
        <li class="active">เพิ่มบริษัทของผู้ให้บริการ</li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box">
              <div class="box-header">
                <!-- <h3 class="box-title">Hover Data Table</h3> -->
                <div class="wrapper_addtypegroup">
                  <el-form
                    size="mini"
                    :label-position="label_position"
                    label-width="150px"
                    :model="ruleForm"
                    ref="ruleForm"
                    class="demo-ruleForm"
                    >
                    <div class="row">
                      <div class="col-xs-6">
                        <el-form size="mini">
                          <el-form-item label="ประเภทการให้บริการ" required>
                            <el-select v-model="ruleForm.service_type" placeholder="กรุณาเลือกประเภทการให้บริการ">
                              <el-option
                                v-for="item in ruleForm.selectType"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="ชื่อบริษัท / ชื่อองค์กร / ชื่อผู้ให้บริการ" required>
                            <el-input placeholder="กรุณากรอกข้อมูล" v-model="ruleForm.name"></el-input>
                          </el-form-item>
                          <el-form-item label="ชื่อแบรนด์ของผู้ให้บริการ" required>
                            <el-input placeholder="กรุณากรอกข้อมูล" v-model="ruleForm.brand_name"></el-input>
                          </el-form-item>
                          <el-form-item label="โลโก้บริษัท" required>
                            <el-upload
                              class="avatar-uploader"
                              action="#"
                              ref="file"
                              :auto-upload="false"
                              :show-file-list="false"
                              :on-change="changePic"
                            >
                              <img v-if="imgUrl" :src="imgUrl" class="avatar" />
                              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                          </el-form-item>
                          <el-form-item label="โค้ดสีบริษัท (ใช้สำหรับรายงาน)" required>
                            <el-input
                              placeholder="กรุณากรอกข้อมูล"
                              v-model="ruleForm.color"
                              type="color"
                              style="width:300px;"
                            ></el-input>
                          </el-form-item>
                        </el-form>
                      </div>
                    </div>
                    <div class="box-footer">
                      <el-button type="primary" @click="submitForm('ruleForm')">บันทึก</el-button>
                    </div>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  data() {
    return {
      ruleForm:{
        service_type:"",
        name:"",
        short_name:"",
        brand_name:"",
        brand_name_en:"",
        color:"",
        selectType: [
          {
            value: "mobile",
            label: "โทรศัพท์เคลื่อนที่"
          },
          {
            value: "broadband",
            label: "อินเทอร์เน็ตความเร็วสูงประจำที่"
          }
        ],
      },
      file: null,
      imgUrl:"",
      label_position:'on-border',
    };
  },
  methods: {
    ...mapActions({
      add_operator: "ListOperator/add_operator",
    }),
    submitForm() {
      if(this.ruleForm.service_type === ""){
        this.$confirm("กรุณาเลือกประเภทของการให้บริการ", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
          showCancelButton: false,
          type: "warning"
        })
      }else if (this.ruleForm.name === ""){
        this.$confirm("กรุณากรอกชื่อบริษัท / ชื่อองค์กร / ชื่อผู้ให้บริการ", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
          showCancelButton: false,
          type: "warning"
        })
      }else if (this.ruleForm.brand_name === ""){
        this.$confirm("กรุณากรอกชื่อแบรนด์ของผู้ให้บริการ", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
          showCancelButton: false,
          type: "warning"
        })
      }else if(!this.file){
        this.$confirm("กรุณาอัปโหลดโลโก้บริษัท", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
          showCancelButton: false,
          type: "warning"
        })
      }else {
        let formData = new FormData();
          formData.append('typeFile', 'logo');
          formData.append('provider_type', this.ruleForm.service_type);
          formData.append('name', this.ruleForm.name);
          formData.append('short_name',this.ruleForm.short_name);
          formData.append('brand_name_th', this.ruleForm.brand_name);
          formData.append('brand_name_en', this.ruleForm.brand_name_en);
          formData.append('color',this.ruleForm.color)
          formData.append('file', this.file);
        this.add_operator(formData);
      }
    },
    // onFileChange(e) {
    //   this.file = e.target.files[0];
    //   this.imgUrl = URL.createObjectURL(this.file);
    // },
    changePic(file){
      this.$refs.file.clearFiles()
      this.file = file.raw
      this.imgUrl = URL.createObjectURL(file.raw);
    },
  },
};
</script>
<style >
/* #preview {
  display: flex;
  justify-content: center;
  align-items: center;
}

#preview img {
  max-width: 100%;
  max-height: 100%;
} */
</style>
